<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="10" :sm="12">
            <el-form-item label="日期范围:">
              <el-date-picker
                v-model="daterange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                class="ele-fluid"
                @change="onDateRangeChoose"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button
                @click="
                  (table.where = {
                    beginTime: $util.toDateString(new Date(), 'yyyy-MM-dd'),
                    endTime: $util.toDateString(new Date(), 'yyyy-MM-dd'),
                  }) && $refs.table.reload()
                "
                >重置</el-button
              >
              <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出 </el-button>
              <!--              <el-button @click="setTemperature" type="primary" icon="el-icon-s-tools" class="ele-btn-icon">设置体温阈值-->
              <!--              </el-button>-->
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="setTemperature" type="primary" icon="el-icon-s-tools" class="ele-btn-icon">设置体温阈值 </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column header-align="center" prop="gradeName" align="center" label="年级" />
          <el-table-column header-align="center" prop="headCount" align="center" label="总人数" />
          <el-table-column header-align="center" prop="abnormalCount" align="center" label="异常人数" />
          <el-table-column header-align="center" prop="unreportCount" align="center" label="未上报人数" />
          <el-table-column label="操作" align="center" width="200px">
            <template #default="{ row }">
              <el-link @click="getStudentList(0, row.gradeId)" icon="el-icon-user-solid" type="danger" :underline="false">异常名单</el-link>
              <el-link @click="getStudentList(1, row.gradeId)" icon="el-icon-user" type="warning" :underline="false">未上报名单</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
      <!--体温阈值设置弹窗-->
      <el-dialog title="体温阈值设置" :visible.sync="showEdit" width="20%">
        <el-input v-model="value" placeholder="请输入要设置的体温阈值" />
        <span slot="footer" class="dialog-footer">
          <el-button @click="showEdit = false">取 消</el-button>
          <el-button type="primary" @click="saveTemperature">确 定</el-button>
        </span>
      </el-dialog>
      <!--异常名单表格-->
      <el-dialog title="异常名单" :visible.sync="errorPopup" width="70%">
        <ele-data-table :config="errortable" :data="errorList" height="calc(90vh - 261px)">
          <template #default="{ index }">
            <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
            <el-table-column label="班级">
              <template #default="{ row }"> {{ row.branchName }}-{{ row.gradeName }}-{{ row.className }} </template>
            </el-table-column>
            <el-table-column prop="studentName" label="学生姓名" width="80" />
            <el-table-column prop="mobile" label="手机号" />
            <el-table-column prop="temperature" label="晨检温度" width="80">
              <template #default="{ row }">{{ row.temperature }}℃</template>
            </el-table-column>
            <el-table-column prop="temperaturenoon" label="午间温度" width="80">
              <template #default="{ row }">{{ row.temperaturenoon }}℃</template>
            </el-table-column>
            <el-table-column prop="cough" label="是否咳嗽" width="80">
              <template #default="{ row }">
                {{ row.cough === 0 ? '否' : '是' }}
              </template>
            </el-table-column>
            <el-table-column prop="familyInfect" label="是否家庭感染">
              <template #default="{ row }">
                {{ row.cough === 0 ? '否' : '是' }}
              </template>
            </el-table-column>
            <el-table-column prop="contact" label="有无感染患者接触史">
              <template #default="{ row }">
                {{ row.cough === 0 ? '无' : '有' }}
              </template>
            </el-table-column>
            <el-table-column prop="leaveCity" label="今日是否离开住地">
              <template #default="{ row }">
                {{ row.cough === 0 ? '否' : '是' }}
              </template>
            </el-table-column>
            <el-table-column prop="destLocation" label="离开驻地所到的地方" />
            <el-table-column prop="currentLocation" label="当前位置" />
            <el-table-column prop="createTime" label="上报时间" sortable="custom" />
          </template>
        </ele-data-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="errorPopup = false">取 消</el-button>
          <el-button type="primary" @click="errorPopup = false">确 定</el-button>
        </span>
      </el-dialog>
      <!--未上报名单表格-->
      <el-dialog title="未上报名单" :visible.sync="noreportPopup" width="50%">
        <ele-data-table :config="noreporttable" :data="noreportList" height="calc(90vh - 261px)">
          <template #default="{ index }">
            <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
            <el-table-column label="班级">
              <template #default="{ row }"> {{ row.branchName }}-{{ row.gradeName }}-{{ row.className }} </template>
            </el-table-column>
            <el-table-column prop="studentName" label="学生姓名" />
          </template>
        </ele-data-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="noreportPopup = false">取 消</el-button>
          <el-button type="primary" @click="noreportPopup = false">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  import {
    exportTemperatureRecordByGrade,
    getTemperatureThresholdBySchool,
    setTemperatureThreshold,
    getAbnormalTemperatureStudentListByGrade,
    getUnreportTemperatureStudentListByGrade,
  } from '@/config/api';

  export default {
    name: 'LeaveReport',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/temperature/getTemperatureRecordByGrade',
          where: {
            beginTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
            endTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
          },
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [], // 表格选中数据
        daterange: [new Date(), new Date()],
        showEdit: false,
        value: '', //体温阈值
        errorList: [], //异常列表
        noreportList: [], //未上报列表
        errorPopup: false,
        noreportPopup: false,
        errortable: {
          page: false,
        },
        noreporttable: {
          page: false,
        },
      };
    },
    methods: {
      // 日期选择改变回调
      onDateRangeChoose() {
        if (this.daterange) {
          this.table.where.beginTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd');
          this.table.where.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd');
        } else {
          this.table.where.beginTime = null;
          this.table.where.endTime = null;
        }
      },
      // 导出数据
      exportData() {
        let data = {};
        if (this.daterange) {
          data.beginTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd');
          data.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd');
        } else {
          data.beginTime = this.$util.toDateString(new Date(), 'yyyy-MM-dd');
          data.endTime = this.$util.toDateString(new Date(), 'yyyy-MM-dd');
        }
        exportTemperatureRecordByGrade(data).then((res) => {
          if (res.data.resCode == 200) {
            window.open(res.data.data);
          } else {
            this.$message({ type: 'info', message: '下载失败' });
          }
        });
      },
      // 体温阈值弹窗
      setTemperature() {
        getTemperatureThresholdBySchool().then((res) => {
          if (res.data.resCode == 200) {
            this.value = res.data.data.value;
          }
        });
        this.showEdit = true;
      },
      // 保存体温阈值
      saveTemperature() {
        let data = new FormData();
        data.append('value', this.value);
        setTemperatureThreshold(data).then((res) => {
          if (res.data.resCode == 200) {
            this.showEdit = false;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 显示异常或者未上报名单
      getStudentList(type, gradeId) {
        if (type === 0) {
          //获取异常名单
          let data = {};
          data.gradeId = gradeId;
          data.beginTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd');
          data.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd');
          getAbnormalTemperatureStudentListByGrade(data).then((res) => {
            if (res.data.resCode == 200) {
              this.errorList = res.data.data;
            }
          });
          this.errorPopup = true;
        }
        if (type === 1) {
          //获取未上报名单
          let data = {};
          data.gradeId = gradeId;
          data.beginTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd');
          data.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd');
          getUnreportTemperatureStudentListByGrade(data).then((res) => {
            if (res.data.resCode == 200) {
              this.noreportList = res.data.data;
            }
          });
          this.noreportPopup = true;
        }
      },
    },
  };
</script>

<style scoped></style>
